import type { HelpFile } from '../../types/help'
import { CreateResourceTestIds } from '../../../testids/CreateResourceTestIds'

export const createResourceHelp: HelpFile = {
  docPage: '/docs/systems/resources',
  texts: {
    [CreateResourceTestIds.cardTitleCreateResource]:
      'Create a new resource of the locked type on the selected target system. Required attributes are derived from the type\u2019s attribute definitions.',
    [CreateResourceTestIds.btnCancelCreateResource]: null,
    [CreateResourceTestIds.btnSubmitCreateResource]: null,
    [CreateResourceTestIds.inputResourceDisplayName]: null,
    [CreateResourceTestIds.inputResourceNativeKey]: null,
    [CreateResourceTestIds.selectClassification]: null,
    [CreateResourceTestIds.selectTargetSystem]: null,
  },
}
